import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, NavLink } from "react-router-dom";
import { getGlobalStats } from "../../../containers/GlobalStats/GlobalStats.actions";
import { Layout, Menu, Grid, Popover } from "antd";
import { MenuFoldOutlined } from "@ant-design/icons";
import ShowIcon from "../../../images/icons/Icons";
import NavMenu from "./NavMenu";
import "./AppHeader.scss";
const { Header } = Layout;
const { useBreakpoint } = Grid;

export default function AppHeader() {
  let location = useLocation();
  const dispatch = useDispatch();

  const screens = useBreakpoint();

  useEffect(() => {
    const doUpdate = location.pathname === "/" ? true : false;
    getGlobalStats(dispatch, doUpdate);
  }, [dispatch, location]);
  return (
    <Header className="AppHeader">
      <div className="AppHeader__left">
        <div className="AppHeader__logo">
          <NavLink to="/">
            <ShowIcon icon={"logo_explorer"} />
          </NavLink>
        </div>
        {screens.md ? (
          <NavMenu type="desktop" />
        ) : (
          <Popover
            content={<NavMenu type="mobile" />}
            trigger="click"
            overlayClassName="Menu__mobile"
            placement="bottomRight"
          >
            <MenuFoldOutlined style={{ color: "#fff", fontSize: "1.5rem" }} />
          </Popover>
        )}
      </div>
      {screens.md ? (
        <Menu theme={"dark"} mode="horizontal">
          <Menu.Item key="wallet">
            <a
              href="https://wallet.centric.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Wallet
            </a>
          </Menu.Item>
          <Menu.Item key="joincentric">
            <a
              href="https://explorer.centric.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Go to BSC Explorer
            </a>
          </Menu.Item>
        </Menu>
      ) : null}
    </Header>
  );
}
